// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","header":"App_header__2L3DO","sidebar":"App_sidebar__3IISB","main":"App_main__uN9ca","banner":"App_banner__3l5YE"};